import * as types from './types';
import { loading, success, error } from 'State/actions';

export const updateCEPCounts = data => {
  return async (dispatch, getState, MPWWebAPI) => {
    dispatch(loading(types.UPDATE_CEP_COUNTS_LOADING, true));

    try {
      await MPWWebAPI.postGenericInsertUpdate('cep/Counts', data);
      dispatch({
        type: types.UPDATE_CEP_COUNTS_UPDATE_SUCCESS,
        payload: true,
      });
    } catch (error) {
      dispatch({
        type: types.UPDATE_CEP_COUNTS_ERRORS,
        payload: error,
      });
    }

    dispatch(loading(types.UPDATE_CEP_COUNTS_LOADING, false));
  };
};

export const fetchSites = () => {
  return async (dispatch, getState, MPWWebAPI) => {
    dispatch(loading(types.UPDATE_CEP_COUNTS_LOADING, true));
    try {
      const response = await MPWWebAPI.getGeneric(`SiteMaster`);
      dispatch(success(types.UPDATE_CEP_COUNTS_GET_SITES, response.data.Data));
    } catch (e) {
      dispatch(error(types.UPDATE_CEP_COUNTS_ERRORS, e));
    }
    dispatch(loading(types.UPDATE_CEP_COUNTS_LOADING, false));
  };
};

export const clearErrors = () => {
  return error(types.UPDATE_CEP_COUNTS_CLEAR_ERRORS, null);
};

export const clearSuccess = () => {
  return success(types.UPDATE_CEP_COUNTS_UPDATE_SUCCESS, false);
};



// WEBPACK FOOTER //
// ./src/pages/updatecepcounts/state/update/actions.js